export enum FirebaseCollections {
  USERS = 'users',
  CONFIGURATION = 'configuration',
  TEMP_BOOKINGS = 'tempBookings',
  COMPLETED_BOOKINGS = 'completedBookings',
  SPOT_AVAILABILITY_LOCKS = 'spotAvailabilityLocks',
  DAILY_ANALYTICS = 'dailyAnalytics',
  CUSTOMER_ANALYTICS = 'customerAnalytics',
}
